import React, { createContext, useContext } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const notify = (message, options = {}) => {
    toast(message, options);
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <ToastContainer position="bottom-right" />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  return useContext(NotificationContext);
};
